import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ApiBootstrap } from "./api/ApiBootstrap.js";
import "./auth/auth.css";
import { AuthProvider } from "./auth/AuthContext.js";
import { AccountPage } from "./pages/AccountPage.js";
import { ApprovalsPage } from "./pages/ApprovalsPage.js";
import { CalendarioFeriasPage } from "./pages/CalendarioFeriasPage.js";
import { IndicadoresEquipePage } from "./pages/IndicadoresEquipePage.js";
import { ForgotPasswordPage } from "./pages/auth/ForgotPasswordPage.js";
import { LoginPage } from "./pages/auth/LoginPage.js";
import { MfaChallengePage } from "./pages/auth/MfaChallengePage.js";
import { MfaSetupPage } from "./pages/auth/MfaSetupPage.js";
import { ResetPasswordPage } from "./pages/auth/ResetPasswordPage.js";
import { EmployeeDetailPage } from "./pages/EmployeeDetailPage.js";
import { EquipePage } from "./pages/EquipePage.js";
import { FeatureFlagsPage } from "./pages/FeatureFlagsPage.js";
import { FeriasPage } from "./pages/FeriasPage.js";
import { DocumentosRhPage } from "./pages/DocumentosRhPage.js";
import { AdmissoesRhPage } from "./pages/AdmissoesRhPage.js";
import { AdmissaoCandidatoPage } from "./pages/AdmissaoCandidatoPage.js";
import { DesligamentosRhPage } from "./pages/DesligamentosRhPage.js";
import { ComunicadosPage, ComunicadoDetailPage } from "./pages/ComunicadosPage.js";
import { ComunicadosRhPage } from "./pages/ComunicadosRhPage.js";
import { FeriasRhPage } from "./pages/FeriasRhPage.js";
import { ForbiddenPage } from "./pages/ForbiddenPage.js";
import { BeneficiosPage } from "./pages/BeneficiosPage.js";
import { DocumentosPage } from "./pages/DocumentosPage.js";
import { HoleritePage } from "./pages/HoleritePage.js";
import { HomePage } from "./pages/HomePage.js";
import { PontoPage } from "./pages/PontoPage.js";
import { IntegrationsPage } from "./pages/IntegrationsPage.js";
import { MinhasSolicitacoesPage } from "./pages/MinhasSolicitacoesPage.js";
import { NotFoundPage } from "./pages/NotFoundPage.js";
import { NotificacoesPage } from "./pages/NotificacoesPage.js";
import { OrgStructurePage } from "./pages/OrgStructurePage.js";
import { OrgChartPage } from "./pages/OrgChartPage.js";
import { PessoasPage } from "./pages/PessoasPage.js";
import { SolicitacoesPage } from "./pages/SolicitacoesPage.js";
import { RequireAuth } from "./routing/RequireAuth.js";
import { RequirePermission } from "./routing/RequirePermission.js";
import { SessionProvider } from "./session/SessionContext.js";
import { AppShell } from "./shell/AppShell.js";
import { SessionTelemetry } from "./telemetry/SessionTelemetry.js";

export function App() {
  return (
    <AuthProvider>
      <SessionProvider>
        <SessionTelemetry />
        <BrowserRouter>
          <ApiBootstrap>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/mfa" element={<MfaChallengePage />} />
              <Route path="/mfa/setup" element={<MfaSetupPage />} />
              <Route path="/recuperar-senha" element={<ForgotPasswordPage />} />
              <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
              <Route path="/admissao/:token" element={<AdmissaoCandidatoPage />} />

              <Route element={<RequireAuth />}>
                <Route element={<AppShell />}>
                  <Route index element={<HomePage />} />
                  <Route
                    path="holerite"
                    element={
                      <RequirePermission permissions={["payroll:read"]}>
                        <HoleritePage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="ferias"
                    element={
                      <RequirePermission permissions={["vacation:read"]}>
                        <FeriasPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="ponto"
                    element={
                      <RequirePermission permissions={["timecard:read"]}>
                        <PontoPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="minhas-solicitacoes"
                    element={
                      <RequirePermission permissions={["request:write"]}>
                        <MinhasSolicitacoesPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="minhas-solicitacoes/:requestId"
                    element={
                      <RequirePermission permissions={["request:write"]}>
                        <MinhasSolicitacoesPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="notificacoes"
                    element={
                      <RequirePermission permissions={["lgpd:export_own"]}>
                        <NotificacoesPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="documentos"
                    element={
                      <RequirePermission permissions={["document:read"]}>
                        <DocumentosPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="comunicados"
                    element={
                      <RequirePermission permissions={["lgpd:export_own"]}>
                        <ComunicadosPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="comunicados/:id"
                    element={
                      <RequirePermission permissions={["lgpd:export_own"]}>
                        <ComunicadoDetailPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="beneficios"
                    element={
                      <RequirePermission permissions={["benefit:read"]}>
                        <BeneficiosPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="equipe"
                    element={
                      <RequirePermission permissions={["vacation:approve"]}>
                        <EquipePage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="equipe/:employeeId"
                    element={
                      <RequirePermission permissions={["vacation:approve"]}>
                        <EmployeeDetailPage backTo="/equipe" />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="aprovacoes"
                    element={
                      <RequirePermission permissions={["vacation:approve"]}>
                        <ApprovalsPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="calendario-ferias"
                    element={
                      <RequirePermission permissions={["vacation:approve"]}>
                        <CalendarioFeriasPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="indicadores-equipe"
                    element={
                      <RequirePermission permissions={["vacation:approve"]}>
                        <IndicadoresEquipePage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="solicitacoes"
                    element={
                      <RequirePermission permissions={["request:resolve"]}>
                        <SolicitacoesPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="ferias-rh"
                    element={
                      <RequirePermission permissions={["vacation:approve_on_behalf"]}>
                        <FeriasRhPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="documentos-rh"
                    element={
                      <RequirePermission permissions={["document:write"]}>
                        <DocumentosRhPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="comunicados-rh"
                    element={
                      <RequirePermission permissions={["document:write"]}>
                        <ComunicadosRhPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="admissoes-rh"
                    element={
                      <RequirePermission permissions={["document:write"]}>
                        <AdmissoesRhPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="desligamentos-rh"
                    element={
                      <RequirePermission permissions={["document:write"]}>
                        <DesligamentosRhPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="pessoas"
                    element={
                      <RequirePermission
                        permissions={["employee:read", "employee:export"]}
                      >
                        <PessoasPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="pessoas/:employeeId"
                    element={
                      <RequirePermission permissions={["employee:read"]}>
                        <EmployeeDetailPage backTo="/pessoas" />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="estrutura"
                    element={
                      <RequirePermission permissions={["org:read"]}>
                        <OrgStructurePage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="organograma"
                    element={
                      <RequirePermission permissions={["org:read"]}>
                        <OrgChartPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="integracoes"
                    element={
                      <RequirePermission permissions={["integration:read"]}>
                        <IntegrationsPage />
                      </RequirePermission>
                    }
                  />
                  <Route
                    path="configuracoes/flags"
                    element={
                      <RequirePermission permissions={["settings:manage"]}>
                        <FeatureFlagsPage />
                      </RequirePermission>
                    }
                  />
                  <Route path="conta" element={<AccountPage />} />
                  <Route path="perfil" element={<AccountPage />} />
                  <Route path="acesso-negado" element={<ForbiddenPage />} />
                  <Route path="404" element={<NotFoundPage />} />
                  <Route path="*" element={<Navigate to="/404" replace />} />
                </Route>
              </Route>
            </Routes>
          </ApiBootstrap>
        </BrowserRouter>
      </SessionProvider>
    </AuthProvider>
  );
}
